import { Select } from "@mantine/core";
import { Location } from "./types";

interface LocationSelectorProps {
  selectedLocationId: number | null;
  locations: Location[];
  onChange: (locationId: number) => void;
}

export const LocationSelector = ({
  selectedLocationId,
  locations,
  onChange,
}: LocationSelectorProps) => {
  return (
    <Select
      label="장소"
      placeholder="장소를 선택하세요"
      value={selectedLocationId?.toString()}
      onChange={(value) => {
        if (value) {
          onChange(parseInt(value));
        }
      }}
      onClick={(e) => e.stopPropagation()}
      data={locations.map((loc) => ({
        value: loc.id.toString(),
        label: loc.name,
      }))}
      styles={{
        label: { color: "black" },
        input: { color: "black" },
        option: { color: "black" },
        dropdown: { backgroundColor: "white" },
      }}
    />
  );
};

